import PropTypes from "prop-types";
import { FiGithub, FiLinkedin, FiInstagram } from "react-icons/fi";
import { socials } from "../../data/profile";
import "./SocialLinks.scss";

export const socialIcons = {
  github: FiGithub,
  linkedin: FiLinkedin,
  instagram: FiInstagram,
};

const SocialLinks = ({ className = "" }) => (
  <ul className={`social-links ${className}`.trim()}>
    {socials.map(({ id, label, url }) => {
      const Icon = socialIcons[id];
      return (
        <li key={id}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-links__link"
            aria-label={`${label} (opens in a new tab)`}
          >
            <Icon aria-hidden="true" />
          </a>
        </li>
      );
    })}
  </ul>
);

SocialLinks.propTypes = {
  className: PropTypes.string,
};

export default SocialLinks;
